import { translate } from "@/i18n/i18n";
import { donationFormatter, formatTime } from "@/lib/utils";
import { InProgressTrainType } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useMemo, useState } from "react";

interface InProgressProps {
    train: InProgressTrainType;
    offset: number;
}

export const InProgress: FC<InProgressProps> = ({ train, offset }) => {
    const [timeRemaining, setTimeRemaining] = useState<number>(0);

    const updateTime = useCallback(() => {
        const now = new Date();
        const totalTime = train.expiresAt.getTime() - train.startedAt.getTime();
        const timeElapsed = now.getTime() - train.startedAt.getTime() - offset;
        setTimeRemaining(Math.max(0, ~~((totalTime - timeElapsed) / 1000)));
    }, [train, offset]);

    useEffect(() => {
        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => clearInterval(interval);
    }, [updateTime]);

    const donationsToNextLevel = useMemo(() => {
        return donationFormatter.format(train.required - train.progress);
    }, [train.progress, train.required]);

    const percent = useMemo(() => {
        return Math.max(0, ~~((train.progress / train.required) * 100));
    }, [train]);

    return (
        <div className="h-[100%] w-[100%] flex flex-row items-stretch justify-between relative">
            <div className={`absolute h-[300%] w-[${percent}%] left-0 top-0 transition-[width] duration-300 ease-in-out progress-bar`} style={{ width: `${Math.min(100, percent)}%`}}/>
            { train.record && train.record.level === train.level && train.record.percent > percent && (<div className="record-bar" style={{ left: `calc(${train.record.percent}% - 2px)`}}/>) }
            <div className="z-1 w-75 pl-3 flex-auto flex flex-col items-stretch justify-center gap-1">
                <div className="text-xl flex flex-row gap-2 ">
                    <div className="px-3 rounded-full train-level">Level {train.level}</div>
                    <div className="font-semibold">
                        Donation
                        <span style={{ marginLeft: "5px" }}>Hype Train</span>
                    </div>
                </div>
                { (train.required - train.progress) > 0 && (
                    <div className="text-base">
                        <span className="text-2xl dono-train-next-level-text">{ donationsToNextLevel }</span> { translate("DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL") }
                    </div>
                )}
            </div>
            <div className="z-1 w-25 pr-3 flex flex-col items-stretch justify-center gap-0">
                <div className="text-end self-end text-2xl dono-train-time-left-text">
                    { formatTime(timeRemaining) }
                </div>
                <div className="text-end self-end text-4xl dono-train-percent-text">
                    { percent }%
                </div>
            </div>
        </div>
    );
}